import axios from 'axios';

// initial state
const contactState = {
  isSubmitted: false,
  isSuccess: false,
  contactMode: null,
};

// getters
const getters = {};

// actions
const actions = {
  POST_CONTACT({ commit, rootState }, form) {
    axios
      .post(`${rootState.api}/contacts`, form)
      .then(() => {
        commit('SET_CALL_BACK_MESSAGE', true);
      })
      .catch((error) => {
        commit('SET_CALL_BACK_MESSAGE', false);
        return console.log(error);
      });
  },
};

// mutations
const mutations = {
  SET_CALL_BACK_MESSAGE(state, bool) {
    state.isSubmitted = true;
    state.isSuccess = bool;
  },
  SET_CONTACT_MODE(state, val) {
    state.contactMode = val
  },
};

export default {
  namespaced: true,
  state: contactState,
  getters,
  actions,
  mutations,
};
